import React from 'react';
import {CurrencyConstants, Money} from "finhelper"
import {Img, RowWrapper} from "../style";
import {Td as TableTd} from '#app/components/Table/styles';
import {OperationSizeConstants} from "#app/pages/IncomeAndExpenses/components/BaseOperationList/OperationSizeConstants";
import {BodyBold} from "#app/components/Text/styles";
import {useTableContext} from "#app/pages/IncomeAndExpenses/components/TableProvider";

const Month = ({year, month, currencyId, children}) => {
    const {toggle, isOpened} = useTableContext();
    const { sum, name, nameEng } = month;

    let id = year.name + name;

    if (sum <= 0) return null;

    const isExpanded = isOpened(id);
    const handleClick = () => toggle(id);

    return <>
        <RowWrapper key={id} border>
            <TableTd flexWidth='2%'>
                <Img
                    className={isExpanded ? 'rotated' : ''}
                    id={'arrow-year-month-' + year.name + '-' + nameEng}
                    onClick={handleClick} src={require('#app/assets/icons/ic_dropdown.svg')}
                    alt=''/>
            </TableTd>
            <TableTd flexWidth={OperationSizeConstants.dateCellWidth}><BodyBold style={{
                cursor: 'pointer',
                display: 'inline-block',
                width: 'auto'
            }} id={'year-month-' + year.name + '-' + nameEng} onClick={handleClick}>{name?.capitalize()}</BodyBold></TableTd>
            <TableTd flexWidth={OperationSizeConstants.editCellWidth}/>
            <TableTd
                flexWidth={OperationSizeConstants.sumCellWidth}><BodyBold>{Money.format(Math.abs(sum))} {CurrencyConstants.getCurrencySignById(currencyId)}</BodyBold></TableTd>
            <TableTd flexWidth={OperationSizeConstants.categoryCellWidth}/>
            <TableTd flexWidth={OperationSizeConstants.subcategoryCellWidth}/>
            <TableTd flexWidth={OperationSizeConstants.tagCellWidth}/>
            <TableTd flexWidth={OperationSizeConstants.descCellWidth}/>
            <TableTd flexWidth={OperationSizeConstants.accountCellWidth}/>
        </RowWrapper>
        {isExpanded && children}
    </>
}

export default React.memo(Month);